:host {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  pointer-events: none;
}

.root-3d {
  width: 100%;
  height: 100%;
  pointer-events: inherit;
}

.camera {
  transform-style: preserve-3d;
  pointer-events: inherit;
  width: 100%;
  height: 100%;
}
